import { db, auth } from "@/plugins/firebase";
import firebase from "firebase";
import "firebase/app";
import { bus } from "@/main";

export async function getPins({ commit }) {
  var pins = [];
  commit("updatePins", pins);

  await db
    .collection("pins")
    .where("state", "!=", "deleted")
    .get()
    .then(async function(docs) {
      if (docs.empty) {
        return;
      }

      for (var i = 0; i < docs.size; i += 1) {
        var doc = docs.docs[i];
        pins.push(doc.data());
      }

      commit("updatePins", pins);
    });
}

export async function createNewPin({ commit }, { pinDetails }) {
  return new Promise((resolve, reject) => {
    const pinRef = db.collection("pins").doc();

    const pin = {
      id: pinRef.id,
      ...pinDetails,
      state: "active",
      createdBy: {
        id: auth.currentUser.uid,
        email: auth.currentUser.email,
        name: auth.currentUser.displayName,
      },
      createdAt: firebase.firestore.FieldValue.serverTimestamp(),
    };

    pinRef
      .set(pin)
      .then(() => {
        console.log("Created new Pin");
        bus.$emit("show-snackbar", {
          text: "New Pin Created!",
          color: "success",
        });
        resolve();
      })
      .catch((err) => {
        bus.$emit("show-snackbar", { text: err, color: "error" });
        reject();
      });
  });
}

export async function updatePin({ commit }, { pinDetails }) {
  return new Promise((resolve, reject) => {
    console.log("updating pin: ", pinDetails);
    const refObj = {
      ...pinDetails,
      state: "updated",
      updatedBy: {
        id: auth.currentUser.uid,
        email: auth.currentUser.email,
        name: auth.currentUser.displayName,
      },
      updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
    };

    db.collection("pins")
      .doc(pinDetails.id)
      .set(refObj, { merge: true })
      .then(() => {
        bus.$emit("show-snackbar", { text: "Pin updated!", color: "success" });
        resolve();
      })
      .catch((err) => {
        bus.$emit("show-snackbar", { text: err, color: "error" });
        reject();
      });
  });
}

export async function deletePin({ commit }, { pinDetails }) {
  console.log("Pin To Delete: ", pinDetails);
  return new Promise((resolve, reject) => {
    const refObj = {
      ...pinDetails,
      state: "deleted",
      deletedBy: {
        id: auth.currentUser.uid,
        email: auth.currentUser.email,
        name: auth.currentUser.displayName,
      },
      deletedAt: firebase.firestore.FieldValue.serverTimestamp(),
    };

    db.collection("pins")
      .doc(pinDetails.id)
      .set(refObj, { merge: true })
      .then(() => {
        bus.$emit("show-snackbar", { text: "Pin deleted!", color: "success" });
        resolve();
      })
      .catch((err) => {
        bus.$emit("show-snackbar", { text: err, color: "error" });
        reject();
      });

    // db.collection('pins').doc(pinDetails.id).delete().then(function () {
    //     bus.$emit("show-snackbar", { text: "Pin Successfully Deleted!", color: "success" });
    //     resolve()
    // }).catch(function (error) {
    //     bus.$emit("show-snackbar", { text: error, color: "error" });
    //     reject()
    // });
  });
}

export async function searchContent(
  { commit },
  { collection, mutation, searchTerm }
) {
  var dataArr = [];
  commit(mutation, dataArr);

  await db
    .collection(collection)
    .where("state", "!=", "deleted")
    .where("searchTerms", "array-contains", searchTerm)
    .get()
    .then(async function(docs) {
      if (docs.empty) {
        return;
      }

      for (var i = 0; i < docs.size; i += 1) {
        var doc = docs.docs[i];
        dataArr.push(doc.data());
      }

      commit(mutation, dataArr);
    });
}

export async function getContentByState(
  { commit },
  { collection, mutation, state }
) {
  var dataArr = [];
  commit(mutation, dataArr);

  await db
    .collection(collection)
    .where("state", "==", state)
    .get()
    .then(async function(docs) {
      if (docs.empty) {
        return;
      }

      for (var i = 0; i < docs.size; i += 1) {
        var doc = docs.docs[i];
        dataArr.push(doc.data());
      }

      commit(mutation, dataArr);
    });
}

export async function getContent({ commit }, { collection, mutation }) {
  var dataArr = [];
  commit(mutation, dataArr);

  await db
    .collection(collection)
    .where("state", "!=", "deleted")
    .get()
    .then(async function(docs) {
      if (docs.empty) {
        return;
      }

      for (var i = 0; i < docs.size; i += 1) {
        var doc = docs.docs[i];
        dataArr.push(doc.data());
      }

      commit(mutation, dataArr);
    });
}

export async function getReviewedEntities(
  { commit },
  { collection, mutation }
) {
  var dataArr = [];
  commit(mutation, dataArr);

  await db
    .collection(collection)
    .where("state", "==", "reviewed")
    .get()
    .then(async function(docs) {
      if (docs.empty) {
        return;
      }

      for (var i = 0; i < docs.size; i += 1) {
        var doc = docs.docs[i];
        dataArr.push(doc.data());
      }

      commit(mutation, dataArr);
    });
}

export async function getProfileByEntityId({ commit }, { entity }) {
  var dataArr = [];
  return new Promise((resolve, reject) => {
    console.log("selected for profile: ", entity);
    if (!entity.id) {
      return;
    }

    db.collection("profiles")
      .where("entityId", "==", entity.id)
      .get()
      .then(async function(docs) {
        if (docs.empty) {
          return;
        }

        for (var i = 0; i < docs.size; i += 1) {
          var doc = docs.docs[i];
          dataArr.push(doc.data());
        }

        console.log("dataArr: ", dataArr);

        commit("updateEntityProfile", dataArr);
        resolve();
      })
      .catch((err) => {
        reject();
      });
  });
}

export async function createNewProfile({ commit }, { details, type }) {
  return new Promise((resolve, reject) => {
    const ref = db.collection("profiles").doc();
    const refObj = {
      id: ref.id,
      ...details,
      state: "created",
      createdBy: {
        id: auth.currentUser.uid,
        email: auth.currentUser.email,
        name: auth.currentUser.displayName,
      },
      createdAt: firebase.firestore.FieldValue.serverTimestamp(),
    };

    console.log("creating profile: ", refObj);
    ref
      .set(refObj)
      .then(() => {
        db.collection("entities")
          .doc(details.entityId)
          .set({ hasProfile: true }, { merge: true })
          .then(() => {
            console.log("updated has Profile to True");
          });
        bus.$emit("show-snackbar", {
          text: type + " created!",
          color: "success",
        });
        resolve();
      })
      .catch((err) => {
        bus.$emit("show-snackbar", { text: err, color: "error" });
        reject();
      });
  });
}

export async function updateProfile({ commit }, { details, type }) {
  return new Promise((resolve, reject) => {
    const refObj = {
      ...details,
      state: "updated",
      updatedBy: {
        id: auth.currentUser.uid,
        email: auth.currentUser.email,
        name: auth.currentUser.displayName,
      },
      updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
    };

    console.log("updating profile: ", refObj);
    db.collection("profiles")
      .doc(details.id)
      .set(refObj, { merge: true })
      .then(() => {
        bus.$emit("show-snackbar", {
          text: type + " updated!",
          color: "success",
        });
        resolve();
      })
      .catch((err) => {
        bus.$emit("show-snackbar", { text: err, color: "error" });
        reject();
      });
  });
}

export async function createNewContent(
  { commit },
  { details, collection, type }
) {
  return new Promise((resolve, reject) => {
    var dbRef = db.collection(collection).where("name", "==", details.name);
    dbRef.get().then(function(querySnapshot) {
      console.log("query Empty: ", !querySnapshot.empty);
      if (!querySnapshot.empty) {
        return resolve();
      }
      const ref = db.collection(collection).doc();

      function createKeywords(name) {
        const arrName = [];
        let curName = "";
        name.split("").forEach((letter) => {
          curName += letter.toLowerCase();
          arrName.push(curName);
        });
        return arrName;
      }

      function generateKeywords(name) {
        const keywordTagName = createKeywords(name);
        return [...new Set(["", ...keywordTagName])];
      }

      details.searchTerms = generateKeywords(details.name);

      console.log(details);

      const refObject = {
        id: ref.id,
        ...details,
        state: "active",
        createdBy: {
          id: auth.currentUser.uid,
          email: auth.currentUser.email,
          name: auth.currentUser.displayName,
        },
        createdAt: firebase.firestore.FieldValue.serverTimestamp(),
      };

      ref
        .set(refObject)
        .then(() => {
          console.log("Created new Content");
          bus.$emit("show-snackbar", {
            text: "New " + type + " Created!",
            color: "success",
          });
          resolve();
        })
        .catch((err) => {
          bus.$emit("show-snackbar", { text: err, color: "error" });
          reject();
        });
    });
  });
}

export async function updateContent({ commit }, { details, collection, type }) {
  return new Promise((resolve, reject) => {
    function createKeywords(name) {
      const arrName = [];
      let curName = "";
      name.split("").forEach((letter) => {
        curName += letter.toLowerCase();
        arrName.push(curName);
      });
      return arrName;
    }

    function generateKeywords(name) {
      const keywordTagName = createKeywords(name);
      return [...new Set(["", ...keywordTagName])];
    }

    details.searchTerms = generateKeywords(details.name);

    const refObj = {
      ...details,
      state: "updated",
      updatedBy: {
        id: auth.currentUser.uid,
        email: auth.currentUser.email,
        name: auth.currentUser.displayName,
      },
      updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
    };
    console.log("updating pin: ", details);
    db.collection(collection)
      .doc(details.id)
      .set(refObj, { merge: true })
      .then(() => {
        bus.$emit("show-snackbar", {
          text: type + " updated!",
          color: "success",
        });
        resolve();
      })
      .catch((err) => {
        bus.$emit("show-snackbar", { text: err, color: "error" });
        reject();
      });
  });
}

export async function deleteContent({ commit }, { details, collection, type }) {
  console.log("Pin To Delete: ", details);
  return new Promise((resolve, reject) => {
    const refObj = {
      ...details,
      state: "deleted",
      deletedBy: {
        id: auth.currentUser.uid,
        email: auth.currentUser.email,
        name: auth.currentUser.displayName,
      },
      deletedAt: firebase.firestore.FieldValue.serverTimestamp(),
    };

    db.collection(collection)
      .doc(details.id)
      .set(refObj, { merge: true })
      .then(() => {
        bus.$emit("show-snackbar", {
          text: type + " deleted!",
          color: "success",
        });
        resolve();
      })
      .catch((err) => {
        bus.$emit("show-snackbar", { text: err, color: "error" });
        reject();
      });

    // db.collection(collection).doc(details.id).delete().then(function () {
    //     bus.$emit("show-snackbar", { text: type + " Successfully Deleted!", color: "success" });
    //     resolve()
    // }).catch(function (error) {
    //     bus.$emit("show-snackbar", { text: error, color: "error" });
    //     reject()
    // });
  });
}
